import { Component, OnInit, ViewChild, Input, EventEmitter, Output } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl, ValidatorFn } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StoreLocationService } from '../../../services/storelocation.service';
import { StoreLocation } from '../../../models/storeLocation';
import { State, STATES } from '../../../../shared/models/state';
import { CampaignType } from '../../../models/CampaignType';
import { DatePipe, formatDate } from '@angular/common';
import { StoreLocationOverrideService } from '../../../services/storelocationOverride.service';
import { StoreLocationOverride } from '../../../models/storeLocationOverride';


const storeLocationValidator: ValidatorFn = (fg: FormGroup) => {
  const source = fg.get('sourceStoreLocationId').value;
  const destination = fg.get('destinationStoreLocationId').value; return source !== null && destination !== null && source != destination
    ? null
    : { storeLocation: true };
};
 
@Component({
  selector: 'app-location-override-form',
  templateUrl: './location-override-form.component.html' 
})

export class LocationOverrideFormComponent implements OnInit {
 
  //input/output parameters
  @Input() title;
  @Input() inputModel: StoreLocationOverride;
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();

  modelForm: FormGroup; 
  submitted = false;

  public storeLocationList: StoreLocation[];
  public stateList: State[] = STATES;  // bind list of states
  public campaignTypeList: CampaignType[];
  public startDate: any;
  public endDate:any;

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private storeLocationOverrideService: StoreLocationOverrideService,
    private storeLocationService: StoreLocationService,
    private notification: MatSnackBar) { }

  // on component load
  ngOnInit() { 
     
    // bind store locations dropdown
    this.storeLocationService.getAll(this.inputModel.brandId).subscribe(locationResult => {
      this.storeLocationList = locationResult;
    });
     
    //const dateReg = /^\d{2}([./-])\d{2}\1\d{4}$/;

    // init dates
    this.startDate = this.inputModel.startDate ? new Date(this.inputModel.startDate) : '';
    this.endDate = this.inputModel.endDate ? new Date(this.inputModel.endDate) : '';

    this.modelForm = this.formBuilder.group({
      id: [this.inputModel.id],
      brandId: [this.inputModel.brandId, Validators.required],
      sourceStoreLocationId: [this.inputModel.sourceStoreLocationId, [Validators.required, Validators.min(1)]],
      destinationStoreLocationId: [this.inputModel.destinationStoreLocationId, [Validators.required, Validators.min(1)]],     
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]]
    },
    { validator: storeLocationValidator });
  }


  // handle form submit  
  onSubmit() {
    this.submitted = true;

      // stop here if form is invalid
      if (this.modelForm.invalid) {
        return; 
      }

      let formValues = this.modelForm.value as StoreLocationOverride;
      formValues.brandId = +this.modelForm.value['brandId'];
      formValues.sourceStoreLocationId = +this.modelForm.value['sourceStoreLocationId'];
      formValues.destinationStoreLocationId = +this.modelForm.value['destinationStoreLocationId'];

      //add
      if (formValues.id == 0) {
        this.storeLocationOverrideService.add(formValues).subscribe(newItem => {
          this.eventEmitter.emit(this.modelForm.value);
          this.activeModal.close(newItem);
          this.showNotification(`The new item was successuly added!`, 'Okay!')
        });
      // update
      } else {
        this.storeLocationOverrideService.update(formValues.id, formValues).subscribe(newItem => {
          this.eventEmitter.emit(this.modelForm.value);
          this.activeModal.close(newItem);
          this.showNotification(`The item was successuly updated!`, 'Okay!') 
        });
      } 
  }

  decline(): void {
    this.activeModal.close(false);
  }

  dismiss(): void {
    this.activeModal.dismiss();
  } 

  // display notifications
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 5000, panelClass: ['snackbar-success'] });
  }
}
